module.exports = __webpack_public_path__ + "static/media/02-schuhe.3dc07ae2.jpg";